export const PERIOD_BAR_STATE = {
  DRAFT: "draft",
  CURRENT: "current",
  FUTURE: "future",
  LAPSED: "lapsed",
};

const VALID_STATES = new Set(Object.values(PERIOD_BAR_STATE));

export function normalizePeriodBarState(raw) {
  const key = String(raw || "")
    .toLowerCase()
    .trim();
  return VALID_STATES.has(key) ? key : PERIOD_BAR_STATE.LAPSED;
}

export function formatPeriodBarAriaLabel(label, state, openEnded) {
  const stateLabel = normalizePeriodBarState(state);
  const labelText = String(label || "").trim();
  const openEndedSuffix = openEnded ? ", open-ended" : "";
  return labelText
    ? `${labelText}, ${stateLabel}${openEndedSuffix}`
    : `${stateLabel}${openEndedSuffix}`;
}

export function shouldHideLabel(element) {
  if (!element) return false;
  const width = element.getBoundingClientRect().width;
  return width < 28;
}
